var chunkMapping = {
	"219": [
		106
	]
};
var idToExternalAndNameMapping = {
	"106": [
		"default",
		"./MainApp",
		264
	]
};
var idToRemoteMap = {
	"106": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 264
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}